import Vue from 'vue'
import Router from 'vue-router'
import xusIndex from "../pages/index.vue";
import products from "../pages/products/products.vue"
import login from "../pages/login/login.vue"
import concerning from "../pages/concerning/concerning.vue"
import documentation from "../pages/technology/documentation.vue"
import userAgreement from "../pages/agreement/userAgreement.vue"
import privacyPolicy from "../pages/agreement/privacyPolicy.vue"

Vue.use(Router)

export default new Router({

    mode: 'history',
    routes: [{
            path: '/',
            name: '首页',
            component: xusIndex,
        },
        {
            path: '/products',
            name: '产品',
            component: products,
        },
        {
            path: '/login',
            name: '登录',
            component: login
        },
        {
            path: '/concerning',
            name: '关于我们',
            component: concerning
        },
        {
            path: '/documentation',
            name: '关于我们',
            component: documentation
        },
        {
            path: '/userAgreement',
            name: '用户协议',
            component: userAgreement
        },
        {
            path: '/privacyPolicy',
            name: '隐私条款',
            component: privacyPolicy
        }
    ]
})